import { BaseWebComponentDataProvider } from '../../../framework/BaseWebComponentDataProvider';
export class ExclusionItemGridBaseDataProvider extends BaseWebComponentDataProvider {
  async getDataForView(): Promise<any> {
    throw new Error('Not implemented');
  }
}
